import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { customersAPI } from '@/utils/api';
import { toast } from 'sonner';
import { Mail, Phone, MapPin, TrendingUp } from 'lucide-react';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCustomers = async () => {
      try {
        const data = await customersAPI.getAll();
        setCustomers(data);
      } catch (error) {
        toast.error('Failed to load customers');
      } finally {
        setLoading(false);
      }
    };
    loadCustomers();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white">Customers</h1>
        <p className="text-gray-400 mt-1">View and manage customer database</p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-400">Loading customers...</div>
      ) : customers.length === 0 ? (
        <Card className="bg-gray-900/50 border-gray-800">
          <CardContent className="py-12 text-center text-gray-400">
            No customers found. Customers will be created automatically from enquiries.
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {customers.map((customer) => (
            <Card key={customer.customer_id} className="bg-gray-900/50 border-gray-800 hover:border-amber-600/50 transition-colors">
              <CardHeader>
                <CardTitle className="text-lg text-white">
                  {customer.name}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                {customer.email && (
                  <div className="flex items-center text-gray-300 text-sm">
                    <Mail className="w-4 h-4 mr-2 text-amber-500" />
                    <span className="truncate">{customer.email}</span>
                  </div>
                )}
                {customer.phone && (
                  <div className="flex items-center text-gray-300 text-sm">
                    <Phone className="w-4 h-4 mr-2 text-amber-500" />
                    <span>{customer.phone}</span>
                  </div>
                )}
                {customer.address && (
                  <div className="flex items-start text-gray-300 text-sm">
                    <MapPin className="w-4 h-4 mr-2 text-amber-500 mt-0.5" />
                    <span className="flex-1">{customer.address}</span>
                  </div>
                )}
                <div className="flex items-center justify-between pt-2 border-t border-gray-800">
                  <div className="text-center">
                    <p className="text-2xl font-bold text-white">{customer.total_enquiries || 0}</p>
                    <p className="text-xs text-gray-400">Enquiries</p>
                  </div>
                  <div className="text-center">
                    <p className="text-2xl font-bold text-white">{customer.total_jobs || 0}</p>
                    <p className="text-xs text-gray-400">Jobs</p>
                  </div>
                  {customer.property_type && (
                    <div className="text-center">
                      <p className="text-sm font-medium text-amber-500 capitalize">{customer.property_type}</p>
                      <p className="text-xs text-gray-400">Property</p>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Customers;